var _defs, _path, _path2, _path3, _path4, _path5, _path6, _line, _path7, _path8, _polyline, _rect, _path9, _path0, _polyline2, _line2, _line3, _line4, _line5, _path1, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 212 172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#748699;}.cls-2{fill:#ccc;opacity:0.29;}.cls-3,.cls-4,.cls-6,.cls-8{fill:#fff;}.cls-4,.cls-5,.cls-6{stroke:#3c4650;}.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{stroke-linecap:round;}.cls-4,.cls-5,.cls-6,.cls-8{stroke-linejoin:round;}.cls-4{stroke-width:1.43px;}.cls-5{fill:#f5f6f7;}.cls-5,.cls-6{stroke-width:1.45px;}.cls-7{fill:none;stroke:#ff4338;stroke-miterlimit:10;stroke-width:1.33px;}.cls-8{stroke:#748699;stroke-width:0.95px;}.cls-9{clip-path:url(#clip-path);}.cls-10{isolation:isolate;}.cls-11{clip-path:url(#clip-path-2);}.cls-12{clip-path:url(#clip-path-3);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    className: "cls-1",
    d: "M108.62,48.74Zm16.38,0Zm-8.84,11.44a.48.48,0,0,0,.39.13h.39c.13,0,.39-.13.52-.13l9.1-9.1a.94.94,0,0,0,0-1.3l-1-1a1,1,0,0,0-.52-.26c-.26,0-.39.13-.65.26l-5.85,5.59V31.84a.89.89,0,0,0-.91-.91h-1.82a.89.89,0,0,0-.91.91V54.33L109,48.74a1,1,0,0,0-.65-.26c-.26,0-.39.13-.65.26l-.91.91a.94.94,0,0,0,0,1.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-2",
    "data-name": "SVGID",
    className: "cls-1",
    x: 97.44,
    y: 23.2,
    width: 37.1,
    height: 44.83
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-3",
    "data-name": "SVGID",
    className: "cls-1",
    x: 106.71,
    y: 30.93,
    width: 20.1,
    height: 29.37
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graphic-data-export") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176,125.26c10.47-2.33,25.49-17.4,26.75-30.09,2.33-23.41-10.47-44.34-34.89-46.67.14-6.38.19-13.29-7-22.1-5.45-6.7-13-7.7-28.34-7.7-17.51,0-32.54,9.77-39,23.71a32.68,32.68,0,0,0-13.3-2.79c-9.31,0-14.66,1.05-23.66,11s-5.37,27.07-5.14,28.59c-.67-.05-1.34-.08-2-.08-15,0-15.31,6.33-15.31,21.73,0,8.8,1.16,16.28,1.12,26.44l84.85-.85Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.83,66.92c.22,1.65.45,2.78.51,3.11-.69,0-1.38-.08-2.08-.08-15.52,0-29.59,10.78-29.59,25.86,0,8.61,8.54,16.29,15,21.29l151.28-1.44c9.43-6.54,21.59-17.51,21.59-30,0-18.85-15.65-34.32-33.75-36,0-.06,0-.11,0-.17,0-4.85,1.21-14.62-6.19-23.24C147.94,19.7,136.83,10.84,121,10.84,103,10.84,87.46,20.4,80.78,34a35.3,35.3,0,0,0-13.72-2.73c-9.61,0-15.13,1-24.41,10.74-4.08,4.27-5.64,9.91-6.1,15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.55,57.06a45.44,45.44,0,0,0,.28,9.86"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M158.93,36.72a24.9,24.9,0,0,0-5.36-10.47C147.94,19.7,136.83,10.84,121,10.84,103,10.84,87.46,20.4,80.78,34a35.3,35.3,0,0,0-13.72-2.73c-9.61,0-15.13,1-24.41,10.74-4.08,4.27-5.64,9.91-6.1,15"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.75,49.66c0-.06,0-.11,0-.17,0-2.92.44-7.61-.82-12.77"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M171.9,115.66c9.43-6.54,21.59-17.51,21.59-30,0-18.85-15.65-34.32-33.75-36"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 23.83,
    y1: 117.07,
    x2: 70.07,
    y2: 116.63
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M37.34,70c-.69,0-1.38-.08-2.08-.08-15.52,0-29.59,10.78-29.59,25.86,0,7.58,6.62,14.44,12.58,19.38"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36.55,57.06c-.1,1.11-.14,2.2-.15,3.25"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "152.53 77.83 152.53 164.66 85.41 164.66"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 77.55,
    y: 71.13,
    width: 69.57,
    height: 88.12
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M34.78,92.59v1.54c0,.14,0,1.11-1,1.11H32.76c-.82,0-.86-.84-.86-1.11V92.59Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M58,88.69H28.73V94.8c0,1,.15,4.16,3.21,4.16h2.13c3.56,0,3.57-3.64,3.57-4.16V92.59H49.42V97H46.09"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "57.96 92.59 53.3 92.59 53.3 97.04 56.31 97.04"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 85.41,
    y1: 87.49,
    x2: 139.39,
    y2: 87.49
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 85.41,
    y1: 96.03,
    x2: 136.09,
    y2: 96.03
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 85.41,
    y1: 104.58,
    x2: 138.78,
    y2: 104.58
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 85.41,
    y1: 113.13,
    x2: 136.09,
    y2: 113.13
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "SVGID-4",
    "data-name": "SVGID",
    className: "cls-1",
    d: "M108.62,48.74Zm16.38,0Zm-8.84,11.44a.48.48,0,0,0,.39.13h.39c.13,0,.39-.13.52-.13l9.1-9.1a.94.94,0,0,0,0-1.3l-1-1a1,1,0,0,0-.52-.26c-.26,0-.39.13-.65.26l-5.85,5.59V31.84a.89.89,0,0,0-.91-.91h-1.82a.89.89,0,0,0-.91.91V54.33L109,48.74a1,1,0,0,0-.65-.26c-.26,0-.39.13-.65.26l-.91.91a.94.94,0,0,0,0,1.3Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-5",
    "data-name": "SVGID",
    className: "cls-1",
    x: 97.44,
    y: 23.2,
    width: 37.1,
    height: 44.83
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-6",
    "data-name": "SVGID",
    className: "cls-1",
    x: 106.71,
    y: 30.93,
    width: 20.1,
    height: 29.37
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 98.81,
    y: 23.2,
    width: 35.74,
    height: 44.83
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataExport);
export default __webpack_public_path__ + "static/media/data-export.04e1e60fee04aaaa644b153985025d9d.svg";
export { ForwardRef as ReactComponent };